import {SET_USER, SET_AGENT, AUTHENTICATE_AGENT, AUTHENTICATE_EMPLOYEE} from '../actions/user';

const initialState = {
    userInfo: null,
    agentInfo: null,
    agentAuthenticated: false,
    employeeAuthenticated: false
};

export const userReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_USER:
            return {...state, userInfo: action.userInfo};
        case SET_AGENT:
            return {...state, agentInfo: action.agentInfo};
        case AUTHENTICATE_AGENT:
            return {...state, agentAuthenticated: action.authenticated};
        case AUTHENTICATE_EMPLOYEE:
            return {...state, employeeAuthenticated: action.authenticated};
        default:
            return {...state};
    }
}